const HomeIcon: React.FC<{selected: boolean}> = ({ selected }) => {
    const color = selected ? '#FFFFFF' : '#494949';
    const secondColor = selected ? '#FFFFFF' : '#D9D9D9';

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_1623_2857" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                <rect x="0.5" width="24" height="24" fill={secondColor}/>
            </mask>
            <g mask="url(#mask0_1623_2857)">
                <path d="M4.5 19V10C4.5 9.68333 4.57083 9.38333 4.7125 9.1C4.85417 8.81667 5.05 8.58333 5.3 8.4L11.3 3.9C11.65 3.63333 12.05 3.5 12.5 3.5C12.95 3.5 13.35 3.63333 13.7 3.9L19.7 8.4C19.95 8.58333 20.1458 8.81667 20.2875 9.1C20.4292 9.38333 20.5 9.68333 20.5 10V19C20.5 19.55 20.3042 20.0208 19.9125 20.4125C19.5208 20.8042 19.05 21 18.5 21H15.5C15.2167 21 14.9792 20.9042 14.7875 20.7125C14.5958 20.5208 14.5 20.2833 14.5 20V15C14.5 14.7167 14.4042 14.4792 14.2125 14.2875C14.0208 14.0958 13.7833 14 13.5 14H11.5C11.2167 14 10.9792 14.0958 10.7875 14.2875C10.5958 14.4792 10.5 14.7167 10.5 15V20C10.5 20.2833 10.4042 20.5208 10.2125 20.7125C10.0208 20.9042 9.78333 21 9.5 21H6.5C5.95 21 5.47917 20.8042 5.0875 20.4125C4.69583 20.0208 4.5 19.55 4.5 19Z" fill={color}/>
            </g>
        </svg>

    );
}

export default HomeIcon; 